/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CreateThirdPersonRequest,
  PersonLightResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateThirdPersonRequestFromJSON,
    CreateThirdPersonRequestToJSON,
    PersonLightResponseFromJSON,
    PersonLightResponseToJSON,
} from '../models/index';

export interface CreateThirdPersonHealthProRequest {
    instituteId: string;
    createThirdPersonRequest: CreateThirdPersonRequest;
}

export interface FindThirdPersonHealthProByInstituteRequest {
    instituteId: string;
}

/**
 * 
 */
export class ThirdPersonApi extends runtime.BaseAPI {

    /**
     * Create a thirdPerson in an institute
     */
    async createThirdPersonHealthProRaw(requestParameters: CreateThirdPersonHealthProRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonLightResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling createThirdPersonHealthPro().'
            );
        }

        if (requestParameters['createThirdPersonRequest'] == null) {
            throw new runtime.RequiredError(
                'createThirdPersonRequest',
                'Required parameter "createThirdPersonRequest" was null or undefined when calling createThirdPersonHealthPro().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/third-persons-healthpro`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateThirdPersonRequestToJSON(requestParameters['createThirdPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonLightResponseFromJSON(jsonValue));
    }

    /**
     * Create a thirdPerson in an institute
     */
    async createThirdPersonHealthPro(requestParameters: CreateThirdPersonHealthProRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonLightResponse> {
        const response = await this.createThirdPersonHealthProRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all health pro third persons by institute
     */
    async findThirdPersonHealthProByInstituteRaw(requestParameters: FindThirdPersonHealthProByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PersonLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findThirdPersonHealthProByInstitute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/third-persons-healthpro`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PersonLightResponseFromJSON));
    }

    /**
     * Get all health pro third persons by institute
     */
    async findThirdPersonHealthProByInstitute(requestParameters: FindThirdPersonHealthProByInstituteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PersonLightResponse>> {
        const response = await this.findThirdPersonHealthProByInstituteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
